import {mod} from 'utils/mod.js';
import HigherOrderStepData from "higherorder/HigherOrderStepData.js";

export default superclass => class extends superclass {
    processGraphics(step, graphics) {
        let _step = Math.floor(step / 2) % 16;
        for (let graphic of graphics) {
            let {type, arg} = graphic;
            let x = _step;
            let y = arg && arg[0] && mod(arg[0], 10);
            let size = arg && arg[1];
            let orientation = arg && arg[2];

            switch (type) {
            case "DRAW":
                this.newStep(x,y,size,orientation);
                break;
            case "ERASE":
                let steps = this.matrix[x].filter(s => s);
                if (y !== undefined) {
                    let step = this.matrix[x][y];
                    if (step) {
                        steps = [step];
                    }
                }
                if (step) {
                    this.deleteSteps(steps);
                }
                break;
            }
        }
        this.updateRedux();
    }
}

